import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Grid, Paper, Dialog, DialogActions, DialogContent, CircularProgress } from "@mui/material";
import { getDailyPracticeQR } from '../../../services/mentorServices/DailyPracticeServices';
import { toast } from 'react-toastify';

const DailyPracticeCard = ({ selectedPractice }) => {
  const [open, setOpen] = useState(false);
  const [qrCode, setQrCode] = useState(null);
  const [qrLoading, setQrLoading] = useState(false);

  useEffect(() => {
    if (open) {
      const fetchQR = async () => {
        setQrLoading(true);
        try {
          const response = await getDailyPracticeQR(selectedPractice.daily_practice_id);
          if (response && response.data) {
            const blob = new Blob([response.data], { type: 'image/png' });
            const url = window.URL.createObjectURL(blob);
            setQrCode(url);
          } else {
            throw new Error('Invalid response data');
          }
        } catch (error) {
          toast.error(error?.response?.data.message || error?.message || error?.error);
          setQrCode(null);
        } finally {
          setQrLoading(false);
        }
      };
      fetchQR();
    }
  }, [open, selectedPractice]);

  const handleViewQR = () => {
    setOpen(true);
  };

  const handleDownloadQR = async () => {
    try {
      const response = await getDailyPracticeQR(selectedPractice.daily_practice_id);
      if (response && response.data) {
        const blob = new Blob([response.data], { type: 'image/png' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `dailyPractice-${selectedPractice.daily_practice_name.trim()}-${selectedPractice.MakerPlan.makerplan_Name.trim()}-${selectedPractice.Maker_Module.module_Name.trim()}-${selectedPractice.Topic.topic_Name.trim()}.png`;
        a.click();
        window.URL.revokeObjectURL(url);
        toast.success("QR code downloaded successfully!");
      } else {
        throw new Error('Invalid response data');
      }
    } catch (error) {
      toast.error(error?.response?.data.message || error?.message || error?.error);
    }
  };

  const handleClose = () => {
    if (qrCode) {
      window.URL.revokeObjectURL(qrCode);
      setQrCode(null);
    }
    setOpen(false);
    setQrLoading(false);
  };


  return (
    <Paper elevation={3} sx={{ padding: 3, maxWidth: 500, margin: "auto" }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Daily Practice Name: {selectedPractice.daily_practice_name}
      </Typography>

      <Grid container spacing={1} display="flex" flexDirection={"column"}>
        {[
          { label: "Maker Plan", value: selectedPractice.MakerPlan.makerplan_Name },
          { label: "Module", value: selectedPractice.Maker_Module.module_Name },
          { label: "Topic", value: selectedPractice.Topic.topic_Name },
          { label: "Type", value: selectedPractice.coding_type },
          { label: "Coding Speed", value: selectedPractice.coding_speed },
          { label: "Level 1", value: selectedPractice.level1_practice_num },
          { label: "Level 2", value: selectedPractice.level2_practice_num },
          { label: "Level 3", value: selectedPractice.level3_practice_num }
        ].map(({ label, value }) => (
          <Grid item xs={12} key={label} display="flex" justifyContent="space-between">
            <Typography variant="body1" fontWeight="bold">
              {label}:
            </Typography>
            <Typography variant="body1">{value}</Typography>
          </Grid>
        ))}
      </Grid>

      <Box mt={3} display="flex" justifyContent="space-around">
        <Button variant="contained" color="primary" size="medium" onClick={handleViewQR}>
          View QR
        </Button>
        <Button variant="contained" color="primary" size="medium" onClick={handleDownloadQR}>
          Download QR
        </Button>
      </Box>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogContent sx={{ p: 0, width: "100%", display: "flex", justifyContent: "center" }}>
          {qrLoading ? (
            <CircularProgress />
          ) : qrCode ? (
            <img src={qrCode} alt="QR Code" style={{ width: '100%' }} />
          ) : (
            <Typography>No QR code available</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained">Close</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default DailyPracticeCard;